import { z } from 'zod';

export const minReviewRequirementsSchema = z.object({
    minFullChecks: z.number().int(),
    minVisualChecks: z.number().int(),
    minCDChecks: z.number().int(),
}).refine(
    (r) => r.minFullChecks + r.minVisualChecks + r.minCDChecks >= 1,
    { message: 'Total of minFullChecks + minVisualChecks + minCDChecks must be at least 1' },
);

export type MinReviewRequirementsType = z.infer<typeof minReviewRequirementsSchema>;

export const reviewBypassTierSchema = z.object({
    requirements: minReviewRequirementsSchema,
    maxUpdaterMistakesPer100: z.number().min(0, 'Must be >= 0'),
    maxFcReviewerMistakesPer100: z.number().min(0, 'Must be >= 0'),
    maxCdReviewerMistakesPer100: z.number().min(0, 'Must be >= 0'),
    mistakesIncreasePerReviewerPercent: z.number().min(0, 'Must be >= 0'),
    allowOnHistoricalCoreDataChange: z.boolean(),
    allowOnHistoricalNonDataChange: z.boolean(),
});

export type ReviewBypassTierType = z.infer<typeof reviewBypassTierSchema>;

export const qualityRequirementsPolicySchema = z.object({
    id: z.number().int(),
    tableName: z.string(),
    minReviewRequirements: minReviewRequirementsSchema,
    bypassTiers: z.array(reviewBypassTierSchema),
    deletable: z.boolean(),
    createdOn: z.string(),
    updatedOn: z.string(),
});

export type QualityRequirementsPolicyType = z.infer<typeof qualityRequirementsPolicySchema>;

export const qualityRequirementsPolicyListSchema = z.array(qualityRequirementsPolicySchema);
export type QualityRequirementsPolicyListType = z.infer<typeof qualityRequirementsPolicyListSchema>;

export const saveQualityRequirementsPolicySchema = z.object({
    // TODO At some point trim should be added, currently it is not possible 
    // due to Names already saved with leading/trailing spaces, 
    // and trim would cause issues when updating those existing policies
    tableName: z.string().min(1, 'Table name is required'),
    minReviewRequirements: minReviewRequirementsSchema,
    bypassTiers: z.array(reviewBypassTierSchema),
});

export type SaveQualityRequirementsPolicyType = z.infer<typeof saveQualityRequirementsPolicySchema>;
